import styled from '@emotion/styled';
import H4 from '@base/H4/H4';
import Paper from '@base/Paper/Paper';
import BreadCrumbs from '@base/BreadCrumbs/BreadCrumbs';
import { Spacings, breakpoints } from '@styles/index';
import useBatchDetails from '@api/hooks/batch/useBatchDetails';
import pushRoute from '@utils/pushRoute';
import PropTypes from 'prop-types';

const Header = styled(Paper)`
  display: flex;
  padding: ${Spacings.SPACING_10B};
  position: fixed;
  top: 72px;
  width: 1136px;
  z-index: 2;
  @media only screen and (max-width: ${breakpoints.mobile}) {
    width: 100%;
    box-shadow: none;
    background-color: var(--color-base-1);
    flex-direction: column;
    position: relative;
    top: initial;
    padding: 24px 0 12px;
  }
`;

const Heading = styled(H4)`
  margin-left: ${Spacings.SPACING_3B};
  @media only screen and (max-width: ${breakpoints.mobile}) {
    margin: ${Spacings.SPACING_6B} 0 0;
    line-height: 150%;
  }
`;

const SubTitle = styled.span`
  color: var(--color-text-secondary);
`;
const BatchTopicGroupHeader = ({ batchUID }) => {
  const { batchDetails: batchData } = useBatchDetails(batchUID);
  const handleOnBackClick = () => {
    if (batchData?.uid)
      pushRoute(
        '/batch/[slug]/[batchUID]',
        `/batch/${batchData.slug}/${batchData.uid}`
      );
  };

  return (
    <Header>
      <BreadCrumbs tags={[]} onBackClick={handleOnBackClick} />
      {batchData?.name ? (
        <Heading color="var(--color-text-primary)">
          Topics covered for
          <SubTitle>{` ${batchData.name}`}</SubTitle>
        </Heading>
      ) : null}
    </Header>
  );
};

export default BatchTopicGroupHeader;
BatchTopicGroupHeader.propTypes = {
  batchUID: PropTypes.string.isRequired
};
